import { render, staticRenderFns } from "./BindsCardExpandContent.vue?vue&type=template&id=472f3f98&"
import script from "./BindsCardExpandContent.vue?vue&type=script&lang=js&"
export * from "./BindsCardExpandContent.vue?vue&type=script&lang=js&"
import style0 from "./BindsCardExpandContent.vue?vue&type=style&index=0&id=472f3f98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports